'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
export default function fileResultsLoading() {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    className: "file-results__loading",
    grow: true
  });
}